var map = {
	"./components/AboutComponent.vue": 6667,
	"./components/AcessibilidadeComponent.vue": 5019,
	"./components/AlunoPendente.vue": 6808,
	"./components/AssuntoForm.vue": 3742,
	"./components/AssuntoTree.vue": 4822,
	"./components/CadastroAssunto.vue": 6591,
	"./components/CadastroCompetencias.vue": 7774,
	"./components/CadastroGrupos.vue": 6412,
	"./components/CadastroUsuario.vue": 3610,
	"./components/CadastrosGerais.vue": 1239,
	"./components/CadastrosGeraisSubGrupos.vue": 8073,
	"./components/ConsultaPorChaveComponent.vue": 6589,
	"./components/ConsultaUsuario.vue": 946,
	"./components/ExampleComponent.vue": 6657,
	"./components/ForgotComponent.vue": 6965,
	"./components/HeaderComponent.vue": 1844,
	"./components/HomeComponent.vue": 5639,
	"./components/LoginComponent.vue": 6875,
	"./components/RegisterComponent.vue": 9173,
	"./components/admin/assistente-juridico/conhecimentos/AssistenteConhecimentoAdminLayout.vue": 9389,
	"./components/assistente-juridico/AssistenteJuridico.vue": 7193,
	"./components/processo/DocumentoEditorComponent.vue": 6138,
	"./components/processo/MovimentacaoProcessualComponent.vue": 4481,
	"./components/processo/MovimentacaoProcessualDetalhesComponent.vue": 8043,
	"./components/processo/OpcoesDownloadComponent.vue": 1639,
	"./components/processo/ProcessoAssuntoArvoreComponent.vue": 3945,
	"./components/processo/ProcessoAssuntoComponent.vue": 740,
	"./components/processo/ProcessoComponent.vue": 66,
	"./components/processo/ProcessoConsultaComponent.vue": 694,
	"./components/processo/ProcessoDistribuicaoLote.vue": 5490,
	"./components/processo/ProcessoDocumentosComponent.vue": 2884,
	"./components/processo/ProcessoIAAnalise.vue": 9738,
	"./components/processo/ProcessoParteCadastrar.vue": 2069,
	"./components/processo/ProcessoPartesComponent.vue": 3532,
	"./components/processo/ProcessoPrazosComponent.vue": 2056,
	"./components/processo/ProcessoResumoModal.vue": 1562,
	"./components/processo/ProcessosAnotacoesComponent.vue": 837,
	"./components/processo/RelatorioProcessosComponent.vue": 7054,
	"./components/processo/SubstabelecimentoComponent.vue": 664,
	"./components/relatorios/RelatorioAcessos.vue": 5300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6106;